(() => {
  'use strict';

  const gate = document.querySelector('[data-seulab-circle-gate]');
  if (!gate) return;

  const storageKey = 'seulab:circle-subscriber';
  const customerKnown = gate.dataset.customerKnown === 'true';
  const serverEligible = gate.dataset.serverEligible === 'true';
  let lastTrigger = null;

  const readLocal = () => {
    try { return localStorage.getItem(storageKey) === 'true'; }
    catch (e) { return false; }
  };

  const writeLocal = (value) => {
    try {
      if (value) localStorage.setItem(storageKey, 'true');
      else localStorage.removeItem(storageKey);
    } catch (e) {}
  };

  if (customerKnown) writeLocal(serverEligible);
  else if (serverEligible) writeLocal(true);

  const isEligible = () => customerKnown ? serverEligible : readLocal();

  const syncState = () => {
    const unlocked = isEligible();
    document.documentElement.classList.toggle('seulab-member-unlocked', unlocked);
    document.documentElement.classList.toggle('seulab-member-locked', !unlocked);
    gate.dataset.unlocked = unlocked ? 'true' : 'false';
    return unlocked;
  };

  const openGate = (trigger) => {
    if (isEligible()) return false;
    lastTrigger = trigger || document.activeElement;
    gate.hidden = false;
    document.documentElement.classList.add('seulab-circle-gate-open');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => {
      const email = gate.querySelector('input[type="email"]');
      const close = gate.querySelector('[data-seulab-circle-close]');
      (email || close)?.focus({ preventScroll: true });
    });
    return true;
  };

  const closeGate = () => {
    gate.hidden = true;
    document.documentElement.classList.remove('seulab-circle-gate-open');
    document.body.style.overflow = '';
    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus({ preventScroll: true });
    }
  };

  syncState();

  gate.addEventListener('click', (event) => {
    if (event.target.closest('[data-seulab-circle-close]')) closeGate();
  });

  document.addEventListener('keydown', (event) => {
    if (!gate.hidden && event.key === 'Escape') closeGate();
  });

  const checkoutLink = (element) => {
    const link = element.closest('a[href]');
    if (!link) return false;
    try {
      const url = new URL(link.href, window.location.origin);
      return /\/checkout(?:\/|$)/.test(url.pathname);
    } catch (e) {
      return false;
    }
  };

  const purchaseControl = (target) => target.closest(
    'button[name="add"], input[name="add"], [data-seulab-add], [name="checkout"], .shopify-payment-button, .shopify-payment-button__button, [data-testid="Checkout-button"]'
  );

  document.addEventListener('click', (event) => {
    if (isEligible()) return;
    const control = purchaseControl(event.target);
    if (!control && !checkoutLink(event.target)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    openGate(control || event.target.closest('a[href]'));
  }, true);

  document.addEventListener('submit', (event) => {
    if (isEligible()) return;
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const action = form.getAttribute('action') || '';
    const submitter = event.submitter;
    const wantsCheckout = submitter && submitter.getAttribute('name') === 'checkout';
    const addsToCart = /\/cart\/add(?:\.js)?(?:\?|$)/.test(action);

    if (!addsToCart && !wantsCheckout) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    openGate(submitter || form);
  }, true);

  const nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  if (nativeFetch) {
    window.fetch = function(input, init) {
      const rawUrl = typeof input === 'string' ? input : (input && input.url) || '';
      let path = rawUrl;
      try { path = new URL(rawUrl, window.location.origin).pathname; } catch (e) {}

      if (!isEligible() && /\/cart\/add(?:\.js)?$/.test(path)) {
        openGate(document.activeElement);
        return Promise.reject(new Error('SEULAB_CIRCLE_REQUIRED'));
      }
      return nativeFetch(input, init);
    };
  }

  window.addEventListener('storage', (event) => {
    if (event.key === storageKey) syncState();
  });

  if (readLocal() && !customerKnown) {
    closeGate();
    syncState();
  }
})();
